import {ErrorMessage, Form, Formik} from 'formik'
import {FC} from 'react'

import {FormButton} from '@/components/common/form/FormButton'
import {FormErrorMessage} from '@/components/common/form/FormErrorMessage'
import {FormItem} from '@/components/common/form/FormItem'
import {GDPRConsent} from '@/components/inputs/GDPRConsent'
import {TextArea} from '@/components/inputs/TextArea'
import {TextInput} from '@/components/inputs/TextInput'
import {UserLocaleHiddenFields} from '@/components/user/UserLocaleHiddenFields'
import {useCommonContent} from '@/content/common'
import {useServiceCommonContent} from '@/content/service-request/common'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {Service} from '@/utils/service-request/types'
import {analytics} from '@/utils/tracking/analytics'
import {domainResolutionSchema} from '@/utils/validations/common/serviceRequest'

import {useServiceRequestSubmit} from '../form/useServiceRequestSubmit'

export const DomainResolutionForm: FC = () => {
  const {t} = useTranslation()
  const {messagePlaceholder, buttonText} = useServiceCommonContent().form
  const {
    domainNameTitle,
    domainNamePlaceholder,
    trademarkNumberTitle,
    trademarkNumberPlaceholder,
    emailLabel,
    emailPlaceholder,
    messageLabel,
  } = useCommonContent()

  const trackDomainResolutionSubmit = () => analytics.track('DomainResolutionSubmit')

  const {handleSubmit, submitError} = useServiceRequestSubmit({
    serviceType: Service.domainResolution,
    onTrack: trackDomainResolutionSubmit,
    errorPath: '/domain-resolution',
  })

  return (
    <>
      <Formik
        initialValues={domainResolutionSchema.getDefault()}
        validationSchema={domainResolutionSchema}
        onSubmit={handleSubmit}
      >
        {({status}) => (
          <Form encType="multipart/form-data">
            <div className="form">
              <UserLocaleHiddenFields />
              <FormItem label={t(emailLabel)} required>
                <ErrorMessage name="email" render={(msg) => <FormErrorMessage message={msg} />} />
                <TextInput type="email" name="email" placeholder={t(emailPlaceholder)} />
              </FormItem>
              <FormItem label={t(domainNameTitle)} required>
                <ErrorMessage name="domain" render={(msg) => <FormErrorMessage message={msg} />} />
                <TextInput name="domain" placeholder={t(domainNamePlaceholder)} />
              </FormItem>
              <FormItem label={t(trademarkNumberTitle)} required>
                <ErrorMessage
                  name="tmNumber"
                  render={(msg) => <FormErrorMessage message={msg} />}
                />
                <TextInput name="tmNumber" placeholder={t(trademarkNumberPlaceholder)} />
              </FormItem>
              <FormItem label={t(messageLabel)}>
                <TextArea name="message" placeholder={t(messagePlaceholder)} />
              </FormItem>
            </div>
            <GDPRConsent />
            <FormButton
              text={t(buttonText)}
              dataTest="serviceSubmit"
              status={status}
              submitError={submitError}
            />
          </Form>
        )}
      </Formik>

      <style jsx>{`
        .form {
          margin-bottom: ${theme.spacing[4]};
        }
        .button-wrapper {
          margin-top: ${theme.spacing[4]};
        }
      `}</style>
    </>
  )
}
